import ProductDesignCaseStudy from './ProductDesignCaseStudy';
import stimulir from './case-studies/stimulir';

export default function StimulirCaseStudy() {
  return <ProductDesignCaseStudy study={stimulir} />;
}
